import ToollBar from "./Toollbar";
import ListBoard from './ListBoard';
import { IOccurrence } from "../types";
import { SelectOption } from "@rio-cloud/rio-uikit";

interface Props {
    data: IOccurrence[];
    handleSearch: (text: string) => void;
    handleDn: (text: string) => void;
    handleResponsible: (text: string) => void;
    handleSupportType: (subject: string) => void;
    handleSort: (optionId: string) => void;
    isLoading: boolean;
    optionsRegionals: SelectOption[];
    handleRegional: (subject: string) => void;
    search?: string;
    dn?: string;
    responsible?: string;
    regional?: string;
    sortBy?: string;
    sortDirection?: string;
    supportType: string;
}

const SupportBoard = ({
    data, 
    handleSearch, 
    handleSupportType, 
    handleDn, 
    handleResponsible, 
    handleSort,
    isLoading, 
    optionsRegionals, 
    handleRegional,
    search,
    dn,
    responsible,
    regional,
    sortBy,
    sortDirection,
    supportType,
}: Props) => {
    return (
        <div>
            <ToollBar 
                handleSearch={handleSearch} 
                handleSupportType={handleSupportType} 
                handleDn={handleDn} 
                handleResponsible={handleResponsible}
                handleSort={handleSort}
                optionsRegionals={optionsRegionals}
                handleRegional={handleRegional}
                search={search}
                dn={dn}
                responsible={responsible}
                regional={regional}
                sortBy={sortBy}
                sortDirection={sortDirection}
                supportType={supportType}
            />
            <ListBoard data={data} isLoading={isLoading} />
        </div>
    )
}

export default SupportBoard;